import { useQuery } from "@tanstack/react-query";
import { getCustomerTransactions } from "../../service/query/auth";

export const useGetCustomerTransactions = ({ membership_id, from_date, to_date, transaction_type, page, enabled }) => {
  return useQuery({
    queryKey: ["customerTransactions", membership_id, from_date, to_date, transaction_type, page],
    queryFn: () => getCustomerTransactions({ membership_id, from_date, to_date, transaction_type, page }),
    enabled: !!enabled,
  });
};